var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8443 14.1605C12.8443 16.9072 9.23461 17.2247 6.52013 17.2247L6.32588 17.2245C4.59644 17.2201 0.194336 17.1062 0.194336 14.1438C0.194336 11.4532 3.65899 11.0937 6.35281 11.0801L6.71438 11.0799C8.4437 11.0842 12.8443 11.1982 12.8443 14.1605ZM6.52013 12.3297C3.11725 12.3297 1.39225 12.9397 1.39225 14.1438C1.39225 15.3588 3.11725 15.9747 6.52013 15.9747C9.92222 15.9747 11.6464 15.3647 11.6464 14.1605C11.6464 12.9455 9.92222 12.3297 6.52013 12.3297ZM6.52013 0.666016C8.85847 0.666016 10.76 2.65102 10.76 5.09102C10.76 7.53102 8.85847 9.51518 6.52013 9.51518H6.49458C4.16104 9.50768 2.27072 7.52185 2.27869 5.08852C2.27869 2.65102 4.181 0.666016 6.52013 0.666016ZM6.52013 1.85602C4.81031 1.85602 3.41911 3.30685 3.41911 5.09102C3.41354 6.86935 4.79434 8.31935 6.49697 8.32602L6.52013 8.92102V8.32602C8.22916 8.32602 9.61954 6.87435 9.61954 5.09102C9.61954 3.30685 8.22916 1.85602 6.52013 1.85602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownProfile);
export default __webpack_public_path__ + "static/media/dropdownProfile.98cda2c7650034e75346789058d2c815.svg";
export { ForwardRef as ReactComponent };